
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/range",
      function () {
        return require("private-next-pages/range/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/range"])
      });
    }
  